<div class="containers">
    <div class="insights-component">
        <div class="header">
            <div class="title" *ngIf="productKpi">{{"inventory.insights.product_performance" | translate}}</div>
            <div class="actions">
                <div *ngIf="variants.length > 0" class="standard-input standard-input-variant">
                    <mat-select [formControl]="variantControl">
                        <mat-option value="all_variants">{{"inventory.product_details.all_variants" | translate}}</mat-option>
                        <mat-option *ngFor="let variant of variants" [value]="variant.variant_id">{{ variant.values.join(' / ') }}</mat-option>
                    </mat-select>
                  </div>
            </div>
        </div>
        <ng-container *ngIf="productKpi">
            <div class="stats-container">
                <!-- Total Product Quotations Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{ "inventory.insights.total_orders" | translate }}</span>
                    </div>
                    <span class="stat-value">{{ productKpi.total_orders ?? 0 | number }}</span>
                    <div class="stat-change">
                    <span class="stat-change-value" [ngClass]="{
                        'negative-change': productKpi.total_orders_change! < 0,
                        'neutral-change': productKpi.total_orders_change === 0
                        }">
                        {{ productKpi.total_orders_change ?? 0 | number }} %
                    </span>
                    <span>{{ "inventory.insights.vs_previous_year" | translate }}</span>
                    </div>
                </div>

                <!-- Average Product Quotations Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{ "inventory.insights.total_orders_value" | translate }}</span>
                    </div>
                    <span class="stat-value">{{productKpi.total_orders_value ?? 0 | number }} €</span>
                    <div class="stat-change">
                    <span class="stat-change-value" [ngClass]="{
                        'negative-change': productKpi.total_orders_value_change! < 0,
                        'neutral-change': productKpi.total_orders_value_change === 0
                        }">
                        {{ productKpi.total_orders_value_change ?? 0 | number }} %
                    </span>
                    <span>{{ "inventory.insights.vs_previous_year" | translate }}</span>
                    </div>
                </div>
                <!-- Total Product Units Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{ "inventory.insights.total_units_ordered" | translate }}</span>
                    </div>
                    <span class="stat-value">{{ productKpi.total_units_ordered ?? 0 | number }}</span>
                    <div class="stat-change">
                    <span class="stat-change-value" [ngClass]="{
                        'negative-change': productKpi.total_units_ordered_change! < 0,
                        'neutral-change': productKpi.total_units_ordered_change === 0
                        }">
                        {{ productKpi.total_units_ordered_change ?? 0 | number }} %
                    </span>
                    <span>{{ "inventory.insights.vs_previous_year" | translate }}</span>
                    </div>
                </div>
                
            </div>
        </ng-container>
        <div class="chart-container">
            <div class="title">{{"inventory.insights.total_orders_value_per_month" | translate}}</div>
            <app-chart *ngIf="!noChartData()"
                type="bar" 
                [data]="barChartData" 
                [options]="barChartOptions"
                >
            </app-chart>
            <div class="no-chart" *ngIf="noChartData()">
                <img src="assets/icones/no-chart.svg" alt="chart">
                <span>{{"inventory.product_details.not_enough_data_available" | translate}}</span>
            </div>
        </div>
        <hr>
        <!-- Product Companies List Table -->
        <div class="title">{{"inventory.insights.top_clients" | translate}}</div>
        <div class="companies-list-container" *ngIf="productCompanies && productCompanies.length > 0">
            <!-- Table Header -->
            <div class="company-header-row">
                <div class="company-name-cell">
                    <span class="header-title">{{"inventory.insights.company.name" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.insights.company.orders" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.insights.company.units_ordered" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.insights.company.total_orders" | translate}}</span>
                </div>
                <div class="col-cell">
                    <span class="header-title">{{"inventory.insights.company.last_order" | translate}}</span>
                </div>
            </div>

            <div class="companies-rows-wrapper">
                <ng-container *ngFor="let productCompany of productCompanies; let i = index">
                    <div class="company-row">
                        <div class="company-name-cell">
                            <div class="col-value">{{productCompany.company_name}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCompany.total_orders}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCompany.total_units_ordered}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCompany.total_orders_value | number:'1.2-2'}} €</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{productCompany.last_order_date | date : DATE_FORMAT}}</div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="no-data" *ngIf="productCompanies && productCompanies.length === 0">
            <img src="assets/images/shop.svg" alt="">
            <span>{{"inventory.product_details.not_enough_data_available" | translate}}</span>
        </div>
    </div>
</div>